module.exports = __webpack_public_path__ + "e7ddf1f055822531a6c7d6ce43e648f1.MP3";